/**
 * Initialisation du checkout Stripe : la majorité du boulot est fait côté serveur par un appel à l'API REST
 * pour créer le CheckoutSession
 *
 * @param containerId
 * @returns {Promise<void>}
 */
export default async function initCheckout(containerId) {
    const formContainer = document.getElementById(containerId);

    const paiementConf = {
        "nonce" : formContainer.dataset.nonce,
        "orderGuid" : formContainer.dataset.orderGuid,
        "stripePublicKey": formContainer.dataset.stripePublicKey,
        "createCheckoutSessionUrl":  formContainer.dataset.createCheckoutSessionUrl,
        "statusUrl" : formContainer.dataset.statusUrl,
    }
    console.log(formContainer, containerId, paiementConf);
    const stripeService = new Stripe(paiementConf.stripePublicKey);
    const fetchClientSecret = async () => {
        const response = await fetch(
            paiementConf.createCheckoutSessionUrl,
            {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    'X-WP-Nonce': paiementConf.nonce
                },
                body: JSON.stringify(
                    {
                        'order-guid' : paiementConf.orderGuid
                    }
                ),
            });
        const { clientSecret } = await response.json();
        return clientSecret;
    };

    const checkout = await stripeService.initEmbeddedCheckout({fetchClientSecret});

    // Mount Checkout
    checkout.mount("#"+containerId);

}

/**
 * Traite le retour de la checkout session
 * @param containerId
 * @returns {Promise<void>}
 */
export async function processCheckoutReturn(containerId) {
    const paiementConf = extractPaiementConfig(containerId);
    const sessionId = getSessionIdFromUrl();
    const loading = document.getElementById('loadingInfosPaiement');
    loading.style.display = 'block';

    let session = null;
    try {
        session = await fetchStripeSession(paiementConf.checkoutStatusUrl, paiementConf.nonce, sessionId);
    } catch (error) {
        console.error('Erreur Stripe :', error);
        alert("Une erreur est survenue lors du traitement du paiement.");
        return;
    } finally {
        loading.style.display = 'none';
    }

    if (!session || !session.status) {
        console.error('Données Stripe invalides :', session);
        // TODO : redirection vers une page d'erreur
        return;
    }
    if (session.status === 'open' || session.status === 'expired') {
        // Le paiement a expiré ou est toujours en cours
        const redirectUrl = paiementConf.orderPaymentUrl + "/?order=" + session.commande_reference;
        showRetryPaymentUI(session, redirectUrl);
        await new Promise(resolve => setTimeout(resolve, 10000));
        window.location.replace(redirectUrl);
    } else if (session.status === 'complete') {
        const paymentSuccessMsg = document.getElementById('paymentSuccessMsg');
        paymentSuccessMsg.style.display = "block";

        const orderStatus = await checkOrderStatusUntilPaid(
            paiementConf.orderStatusUrl,
            paiementConf.nonce,
            session.commande_reference
        );

        paymentSuccessMsg.style.display = "none";

        //document.getElementById('customer-email').textContent = session.customer_email;
        showOrderStatusMessage(orderStatus, session.customer_email);
    }
}

function showOrderStatusMessage(orderStatus, customerEmail) {
    const msgContainer = document.getElementById('orderStatusMsg');
    const msgText = document.getElementById('orderStatusText');

    // Sélectionne le message
    const message = window.checkOrderStatusMessages[orderStatus];
    if (!message) {
        console.error('Message inconnu pour status :', orderStatus);
        return;
    }

    msgText.innerHTML = message;
    const emailSpan = document.getElementById('customer-email');
    if (emailSpan) emailSpan.textContent = customerEmail;

    msgContainer.style.display = 'block';
}

/**
 * Tente jusqu'à 5 fois (par défaut) de vérifier que la commande a le statut "Payee"
 *
 * @param {string} orderPaymentUrl
 * @param {string} nonce
 * @param {string} reference
 * @param {number} maxAttempts
 *
 * @returns {Promise<string>} true si la commande est payée, false sinon
 */
async function checkOrderStatusUntilPaid(orderPaymentUrl, nonce, reference, maxAttempts = 5) {
    let attempts = 0;

    while (attempts < maxAttempts) {
        const status = await checkOrderStatus(orderPaymentUrl, nonce, reference);

        if (status === 'Payee') {
            return 'paid';
        } else if ( status === 'PaiementEnAttente') {
            return 'pending';
        } else if ( status === 'Annulee') {
            return 'canceled';
        } else if ( status === 'EchecPaiement') {
            return 'paymentFailed';
        } // else  = en cours de traitement on doit itérer

        console.log(`Tentative ${attempts + 1} / ${maxAttempts}. Nouvelle tentative dans 2s.`);
        attempts++;
        await new Promise(resolve => setTimeout(resolve, 2000));
    }

    return 'timeout';
}



function extractPaiementConfig(containerId) {
    const formContainer = document.getElementById(containerId);
    return {
        nonce: formContainer.dataset.nonce,
        stripePublicKey: formContainer.dataset.stripePublicKey,
        checkoutStatusUrl: formContainer.dataset.checkoutStatusUrl,
        orderPaymentUrl: formContainer.dataset.orderPaymentUrl,
        orderStatusUrl: formContainer.dataset.orderStatusUrl,
    };
}

function getSessionIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('session_id');
}

async function fetchStripeSession(checkoutStatusUrl, nonce, sessionId) {
    const response = await fetch(checkoutStatusUrl, {
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-WP-Nonce": nonce,
        },
        method: "POST",
        body: JSON.stringify({ session_id: sessionId }),
    });
    return response.json();
}


/**
 * Affiche l'UI pour retenter un paiement si la vérification du checkout indique un problème
 * Dans ce cas redirect vers la page de paiement auto sur compteur et bouton pour y aller immmédiatement
 * @param session
 * @param paymentUrl
 */
function showRetryPaymentUI(session, paymentUrl) {
    const openMsg = document.getElementById('paymentOpenMsg');
    const returnBtn = document.getElementById('returnToPaymentBtn');
    const countdownEl = document.getElementById('countdown');

    returnBtn.setAttribute('href', paymentUrl);
    returnBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window.location.replace(paymentUrl);
    });

    openMsg.style.display = "block";
    let seconds = 10;
    countdownEl.textContent = seconds;

    const timer = setInterval(() => {
        seconds--;
        countdownEl.textContent = seconds;
        if (seconds <= 0) {
            clearInterval(timer);
        }
    }, 1000);
}

/**
 * Interroge l'API une seule fois pour obtenir le statut de la commande
 * @param {string} orderPaymentUrl
 * @param {string} nonce
 * @param {string} reference
 * @returns {Promise<string|null>} Le statut de la commande, ou null en cas d'erreur
 */
async function checkOrderStatus(orderPaymentUrl, nonce, reference) {
    try {
        const response = await fetch(`${orderPaymentUrl}/?id=${reference}`, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-WP-Nonce": nonce,
            },
            method: "GET",
        });

        const result = await response.json();

        if (response.status === 200) {
            if (!result || !result.statutCommande) {
                console.error("Réponse vide ou mal formée :", result);
                return "endpointError";
            }
        } else if (response.status === 404) {
            console.error("Commande non trouvée", response);
            return "endpointError"; // TODO code d'erreur spécifique
        }

        return result.statutCommande;

    } catch (error) {
        console.error("Erreur lors de la requête de statut :", error);
        return "endpointError";
    }
}




